import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            class="ns-close-selected-filter"
            onClick={() => filter.remove()}
        >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.2002 3.2959L12.7047 12.8004" stroke="#393d3c" stroke-width="1.6" stroke-linecap="round" />
                <path d="M3.2002 12.7046L12.7047 3.20011" stroke="#393d3c" stroke-width="1.6" stroke-linecap="round" />
            </svg>
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters?.filter(filter => filter.name !== 'Tags - Hidden').length > 0 && (
            <div class="ns-selected-filters-container">
                {filters.filter(filter => filter.name !== 'Tags - Hidden')?.map(filter => (
                    <div class="ns-selected-filter-option">
                        <span class="ns-selected-filter-name">
                            {filter.name === 'Color' ? (
                                <div class="ns-selected-filter-value-container">
                                    <span class="ns-selected-filter-color" style={{ backgroundColor: filter.value.toLowerCase() }}></span>
                                    <span>{filter.value}</span>
                                </div>
                            ) : (
                                <span>{filter.value}</span>
                            )}
                        </span>
                        <FilterRemoveButton filter={filter} />
                    </div>
                ))}
                <a
                    href="javascript:void(0)"
                    class="ns-clear-filters-link"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear All
                </a>
            </div>
        )
    )
}
